import { render, staticRenderFns } from "./DeliverablesSelectorList.view.vue?vue&type=template&id=623459c0&scoped=true&"
import script from "./DeliverablesSelectorList.view.vue?vue&type=script&lang=js&"
export * from "./DeliverablesSelectorList.view.vue?vue&type=script&lang=js&"
import style0 from "./DeliverablesSelectorList.view.vue?vue&type=style&index=0&id=623459c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623459c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('623459c0')) {
      api.createRecord('623459c0', component.options)
    } else {
      api.reload('623459c0', component.options)
    }
    module.hot.accept("./DeliverablesSelectorList.view.vue?vue&type=template&id=623459c0&scoped=true&", function () {
      api.rerender('623459c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/overlays/popups/deliverables/DeliverablesSelectorList.view.vue"
export default component.exports